/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Pergi_S2Inputs */

const en_tut_pergi_s2 = /** @type {(inputs: Tut_Pergi_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its content is assembled from real events: unread inbox items, mentions, direct messages, issues that changed, waiting approvals, and Digital Deputy actions.`)
};

const id_tut_pergi_s2 = /** @type {(inputs: Tut_Pergi_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isinya disusun dari kejadian nyata: inbox yang belum dibaca, mention, pesan langsung, issue yang berubah, approval yang menunggu, dan tindakan Wakil Digital.`)
};

/**
* | output |
* | --- |
* | "Its content is assembled from real events: unread inbox items, mentions, direct messages, issues that changed, waiting approvals, and Digital Deputy actions." |
*
* @param {Tut_Pergi_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_pergi_s2 = /** @type {((inputs?: Tut_Pergi_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Pergi_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_pergi_s2(inputs)
	return en_tut_pergi_s2(inputs)
});